(() => {
    class MenuProductPreview {
      constructor(menu) {
        this.menu = menu;
        this.card = menu.querySelector('[data-menu-product-card]');

        if (!this.card) return;

        this.image = this.card.querySelector('.mega-menu-product__image');
        this.title = this.card.querySelector('[data-menu-product-title]');
        this.price = this.card.querySelector('[data-menu-product-price]');
        this.caption = this.card.querySelector('[data-menu-product-caption]');

        // По умолчанию товар скрыт.
        this.hide();

        menu.addEventListener('pointerover', (event) => {
          const link = event.target.closest('.mega-menu__link');

          if (!link || !menu.contains(link)) return;

          if (link.matches('[data-menu-product]')) {
            this.show(this.readLink(link));
          } else {
            this.hide();
          }
        });

        menu.addEventListener('focusin', (event) => {
          const link = event.target.closest('.mega-menu__link');

          if (!link || !menu.contains(link)) return;

          if (link.matches('[data-menu-product]')) {
            this.show(this.readLink(link));
          } else {
            this.hide();
          }
        });

        menu.addEventListener('pointerleave', () => this.hide());

        menu.addEventListener('focusout', (event) => {
          if (!menu.contains(event.relatedTarget)) {
            this.hide();
          }
        });
      }

      readLink(link) {
        return {
          url: link.href,
          title: link.dataset.productTitle || '',
          price: link.dataset.productPrice || '',
          caption: link.dataset.productCaption || '',
          image: link.dataset.productImage || '',
          alt: link.dataset.productImageAlt || link.dataset.productTitle || '',
        };
      }

      hide() {
        window.clearTimeout(this.changeTimer);
        this.card.classList.remove('is-changing');
        this.card.classList.add('is-hidden');
      }

      show(product) {
        window.clearTimeout(this.changeTimer);

        this.card.classList.remove('is-hidden');
        this.card.classList.add('is-changing');

        this.changeTimer = window.setTimeout(() => {
          this.card.href = product.url;

          if (this.title) this.title.textContent = product.title;
          if (this.price) this.price.textContent = product.price;
          if (this.caption) this.caption.textContent = product.caption;

          if (this.image && product.image) {
            this.image.srcset = '';
            this.image.src = product.image;
            this.image.alt = product.alt;
          }

          this.card.classList.remove('is-changing');
        }, 110);
      }
    }

    const initMenuProductPreviews = (root = document) => {
      root.querySelectorAll('[data-enhanced-product-menu]').forEach((menu) => {
        if (menu.dataset.productPreviewReady) return;

        menu.dataset.productPreviewReady = 'true';
        new MenuProductPreview(menu);
      });
    };

    initMenuProductPreviews();

    document.addEventListener('shopify:section:load', (event) => {
      initMenuProductPreviews(event.target);
    });
  })();